export const Dictionary = {
  __generic_api_failure: "Qualcosa non è andato.",
  __generic_api_error:
    "Impossibile eseguire l'operazione: il server è irraggiungibile.",
  __invalid_token:
    "La tua richiesta non può essere completata, il token non è valido. Il token di sicurezza potrebbe essere scaduto o essere già stato utilizzato.",
  __generic_api_403: "Non hai l'autorizzazione per eseguire questa azione.",
  __you_are_offline: "Non sei connesso a Internet.",
  __coming_soon:
    "Questa feature al momento è in lavorazione, sarà resa disponibile al più presto.",
};
